import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL_V3, get } from "../api";
import { BillNetwork } from "./useBillAirtimeProviders";

/**
 * Cable TV providers from the provider-agnostic bills layer (/v3/bills).
 */
function useBillCableProviders(
  options?: QueryObserverOptions<APIResponse<BillNetwork[]>, APIError>
) {
  const {
    data: providers,
    isLoading: fetchingProviders,
    isError: isProvidersError,
    error: providersError,
  } = useQuery<APIResponse<BillNetwork[]>, APIError>(
    "bills-cable-providers",
    async () =>
      await get(API_URL_V3 + "/bills/cable-tv/providers", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    providers: providers?.data || [],
    fetchingProviders,
    isProvidersError,
    providersError,
  };
}

export default useBillCableProviders;
